"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextLabel1 = void 0;
var _createText = require("./createText");
const TextLabel1 = (0, _createText.createText)('label1');
exports.TextLabel1 = TextLabel1;